<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import AdminDashboard from './Dashboard.vue';
import ParentDashboard from './ParentDashboard.vue';
import PrefectDashboard from './PrefectDashboard.vue';
import TeacherDashboard from './TeacherDashboard.vue';
import {
  ADMIN_ROLE_CODES,
  FACULTY_ROLE_CODES,
  PREFECT_ROLE_CODES,
  RoleCode,
} from '@/constants/accounts';

// One /employee dashboard route; the active role picks which one shows.
// Nothing renders until the shell has loaded the role.
const store = useStore();
const roleCode = computed(() => store.getters.activeRoleCode);
</script>

<template>
  <ParentDashboard v-if="roleCode === RoleCode.Parent" />
  <PrefectDashboard v-else-if="PREFECT_ROLE_CODES.includes(roleCode)" />
  <AdminDashboard v-else-if="ADMIN_ROLE_CODES.includes(roleCode)" />
  <TeacherDashboard v-else-if="FACULTY_ROLE_CODES.includes(roleCode)" />
</template>
